<template>
	<div>
        <!--Luiz Trindade - Modal para listar os pedidos feitos pelo ifood-->
		<div class="modal fade" id="mdlistarpedidosifood">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">
                    <!--Luiz Trindade - Cabeçalho do modal-->
					<div class="modal-header">
                        <!--Luiz Trindade - Título do modal-->
						<h4 class="modal-title">
                            <!-- <i class="fa fa-search"></i>  -->
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="#CCCCCC" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.428 1.67c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006c4.244 0 7.184-3.854 7.184-6.998 0-2.29-2.175-3.293-4.244-3.293zm11.328 0c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006C21.061 11.96 24 8.107 24 4.963c0-2.29-2.18-3.293-4.244-3.293zM14.172 14.52l2.435 1.834c-2.17 2.07-6.124 3.525-9.353 3.17A8.913 8.913 0 01.23 14.541H0a9.598 9.598 0 008.828 7.758c3.814.24 7.323-.905 9.947-3.13l-.004.007 1.08 2.988 1.555-7.623-7.234-.02Z"/>
							</svg>
                            Listagem de pedidos do ifood
                        </h4>
						
                        <!--Luiz Trindade - Botão para fechar o modal-->
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
					</div>

                    <!--Luiz Trindade - Corpo do modal-->
					<div class="modal-body">

                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-end">
                                <button class="btn btn-primary" @click="mtdexibirmodalpedidosanteriores()">
                                    <i class="fa fa-history" aria-hidden="true"></i>
                                    Anteriores
                                </button>
                            </div>
                        </div>
                        <br>

                        <div style="overflow-y: auto; max-height: 450px;">
                            <div>
                                <!--Tabela com informações de pedidos-->
                                <table class="table table-bordered table-sm table-hover">
                                    <!--Luiz Trindade - Cabeçalho da tebela-->
                                    <thead class="thead-dark">
                                        <tr style="text-align: center;">
                                            <th>Ação</th>
                                            <th>Código ifood</th>
                                            <th>Cliente</th>
                                            <th>Data de criação</th>
                                            <th>Subtotal</th>
                                            <th>Taxa de entrega</th>
                                        </tr>
                                    </thead>
    
                                    <!--Luiz Trindade - Corpo da tabela-->
                                    <tbody v-show="lstPedidosIfoodDetalhados.length > 0">
                                        <tr v-for="(pedido, index) in lstPedidosIfoodDetalhados" v-bind:key="index">
                                            <!--Luiz Trindade - Botão de "ações"-->
                                            <td style=" display: flex; align-items: center; justify-content: space-around;">
                                                <button class="btn btn-success" @click.prevent="verificarexistenciaproduto(pedido.id)" 
                                                title="Importar">
                                                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                                                    <!-- Importar -->
                                                </button>
                                            
                                                <button class="btn btn-success" @click="showOrderDetails(pedido.id)"
                                                title="Detalhes">
                                                    <i class="fa fa-list" aria-hidden="true"></i>
                                                    <!-- Detalhes -->
                                                </button>
                                            </td>
    
                                            <!--Luiz Trindade - Id do pedido do ifood-->
                                            <td>{{ pedido.displayId }}</td>
                                            <!-- <td>{{ pedido.orderId }}</td> -->
                                            
                                            <!--Luiz Trindade - Nome do cliente-->
                                            <td>{{ pedido.customer.name }}</td>
                                            
                                            <!--Luiz Trindade - Data de pedido-->
                                            <td>{{ formatarDataIfood(pedido.createdAt) }}</td>
                                            
                                            <!--Luiz Trindade - Exibir subtotal(valor que será computado pelo PDV)-->
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(pedido.total.subTotal) }}</td>
                                            
                                            <!--Luiz Trindade - Taxa de entrega-->
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(pedido.total.deliveryFee) }}</td>
                                        </tr>
                                    </tbody>

                                </table>
                                
                                <div style="text-align: center;" v-show="lstPedidosIfoodDetalhados.length == 0">
                                    <h6>Aguardando novos pedidos...</h6>
                                </div>
                            </div>
                            
                        </div>
					</div>        

					<div class="modal-footer">
                        <!--Luiz Trindade - Botão para cancelar e fechar o modal-->
						<button type="button" class="btn btn-secondary btn-sm" 
                            data-dismiss="modal">
                            <i class="fa fa-close"></i> 
                            Cancelar
                        </button>
					</div>        
				</div>
			</div>
		</div>      
        
        <!--Luiz Trindade - Modal para exibir detalhes de um pedido do ifood-->
        <div class="modal fade" id="mdldetalhespedidoifood" style="z-index: 99999;">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçalho do modal-->
					<div class="modal-header">
                        <!--Luiz Trindade - Título do modal-->
						<h4 class="modal-title">
                            <!-- <i class="fa fa-search"></i>  -->
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="#CCCCCC" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.428 1.67c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006c4.244 0 7.184-3.854 7.184-6.998 0-2.29-2.175-3.293-4.244-3.293zm11.328 0c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006C21.061 11.96 24 8.107 24 4.963c0-2.29-2.18-3.293-4.244-3.293zM14.172 14.52l2.435 1.834c-2.17 2.07-6.124 3.525-9.353 3.17A8.913 8.913 0 01.23 14.541H0a9.598 9.598 0 008.828 7.758c3.814.24 7.323-.905 9.947-3.13l-.004.007 1.08 2.988 1.555-7.623-7.234-.02Z"/>
							</svg>
                            Detalhes do pedido ifood
                        </h4>
						
                        <!--Luiz Trindade - Botão para fechar o modal-->
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
					</div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body">
                        
                            <div class="row">
                                <!--Luiz Trindade - Cliente-->
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label for="detalheclientenomeinfo">Cliente:</label>
                                    <input type="text" class="form-control form-control-sm" id="detalheclientenomeinfo" 
                                        v-model="detalheNome"disabled :title="detalheNome"
                                        style="overflow: auto; text-overflow: ellipsis">
                                </div>

                                <!--Luiz Trindade - Pedido-->
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label for="detalhepedidoinfo">Pedido:</label>
                                    <input type="text" class="form-control form-control-sm" id="detalhepedidoinfo" 
                                        v-model="detalhePedido"disabled :title="detalhePedido"
                                        style="overflow: auto; text-overflow: ellipsis">
                                </div>

                                <!--Luiz Trindade - Data de envio-->
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label for="detalhedatainfo">Data de envio:</label>
                                    <input type="text" class="form-control form-control-sm" id="detalhedatainfo" 
                                        v-model="detalheDataPreparo"disabled :title="detalheDataPreparo"
                                        style="overflow: auto; text-overflow: ellipsis">
                                </div>
                                
                                <!--Luiz Trindade - Tabela-->
                                <div class="col" style="overflow-y: auto; max-height: 300px;">
                                    <hr>
                                    <!--Luiz Trindade - Tabela para exibir informações de itens pedidos-->
                                    <table class="table table-bordered table-sm table-hover">
                                        <!--Luiz trindade - Cabeçalho da tabela-->
                                        <thead class="thead-dark">
                                            <tr style="text-align: center;">
                                                <th>Descrição</th>
                                                <th>Quantidade</th>
                                                <th>valor</th>
                                            </tr>
                                        </thead>
                                        
                                        <!--Luiz Trindade - Corpo da tabela-->
                                        <tbody>
                                            <tr v-for="(item, index) in detalhesItens" :v-bind="index">
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td style="text-align: right;">{{ mtdformatavalordecimal(item.price) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr>

                            <div class="col">
                                <ul class="list-group">
                                    <a class="list-group-item lstdetrec">
                                        Taxas adicionais 
                                        <span class="badge badge-success bdgtitulos" style="background: #CC330D;">
                                            {{ taxasAdicionais }}
                                        </span>
                                    </a>
                                </ul>

                                <ul class="list-group">
                                    <a class="list-group-item lstdetrec">
                                        Vantagens adicionais
                                        <span class="badge badge-success bdgtitulos" style="background: #6e9fa5;">
                                            {{ vantagensAdicionais }}
                                        </span>
                                    </a>
                                </ul>

                                <ul class="list-group">
                                    <a class="list-group-item lstdetrec">
                                        Taxa de entrega 
                                        <span class="badge badge-success bdgtitulos" style="background: #5C8F94;">
                                            {{ taxaEntrega }}
                                        </span>
                                    </a>
                                </ul>

                                <ul class="list-group">
                                    <a class="list-group-item lstdetrec">
                                        Valor Total 
                                        <span class="badge badge-success bdgtitulos" style="background: #2F3C48;">
                                            {{ valorTotal }}
                                        </span>
                                    </a>
                                </ul>

                                <ul class="list-group">
                                    <a class="list-group-item lstdetrec">
                                        Subtotal 
                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">
                                            {{ subTotal }}
                                        </span>
                                    </a>
                                </ul>
                            </div>
                    </div>

                    <div class="modal-footer">
                        <!--Luiz Trindade - Botão para cancelar e fechar o modal-->
						<button type="button" class="btn btn-secondary btn-sm" 
                            data-dismiss="modal">
                            <i class="fa fa-close"></i> 
                            Cancelar
                        </button>
					</div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="mdlistarpedidosifoodanteriores">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçalho do modal-->
					<div class="modal-header">
                        <!--Luiz Trindade - Título do modal-->
						<h4 class="modal-title">
                            <!-- <i class="fa fa-search"></i>  -->
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="#CCCCCC" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.428 1.67c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006c4.244 0 7.184-3.854 7.184-6.998 0-2.29-2.175-3.293-4.244-3.293zm11.328 0c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006C21.061 11.96 24 8.107 24 4.963c0-2.29-2.18-3.293-4.244-3.293zM14.172 14.52l2.435 1.834c-2.17 2.07-6.124 3.525-9.353 3.17A8.913 8.913 0 01.23 14.541H0a9.598 9.598 0 008.828 7.758c3.814.24 7.323-.905 9.947-3.13l-.004.007 1.08 2.988 1.555-7.623-7.234-.02Z"/>
							</svg>
                            Pedidos do dia que já foram importados
                        </h4>
						
                        <!--Luiz Trindade - Botão para fechar o modal-->
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
					</div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body">
                        <div style="overflow-y: auto; max-height: 450px;">
                            <div>
                                <!--Tabela com informações de pedidos-->
                                <table class="table table-bordered table-sm table-hover">
                                    <!--Luiz Trindade - Cabeçalho da tebela-->
                                    <thead class="thead-dark">
                                        <tr style="text-align: center;">
                                            <th>Ação</th>
                                            <th>Código ifood</th>
                                            <th>Cliente</th>
                                            <th>Data de criação</th>
                                            <th>Subtotal</th>
                                            <th>Taxa de entrega</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
    
                                    <!--Luiz Trindade - Corpo da tabela-->
                                    <tbody v-show="lstPedidosIfoodDetalhadosAnteriores.length > 0">
                                        <tr v-for="(pedido, index) in lstPedidosIfoodDetalhadosAnteriores" v-bind:key="index">
                                            <!--Luiz Trindade - Botão de "ações"-->
                                            <td style=" display: flex; align-items: center; justify-content: space-around;">
                                                <button class="btn btn-success" @click.prevent="verificarexistenciaproduto(pedido.id)" 
                                                title="Importar">
                                                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                                                    <!-- Importar -->
                                                </button>
                                                
                                                <button class="btn btn-success" @click="showOrderDetails(pedido.id)"
                                                title="Detalhes">
                                                    <i class="fa fa-list" aria-hidden="true"></i>
                                                    <!-- Detalhes -->
                                                </button>
                                            </td>
    
                                            <!--Luiz Trindade - Id do pedido do ifood-->
                                            <td>{{ pedido.displayId }}</td>
                                            
                                            <!--Luiz Trindade - Nome do cliente-->
                                            <td>{{ pedido.customer.name }}</td>
                                            
                                            <!--Luiz Trindade - Data de pedido-->
                                            <td>{{ formatarDataIfood(pedido.createdAt) }}</td>
                                            
                                            <!--Luiz Trindade - Exibir subtotal(valor que será computado pelo PDV)-->
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(pedido.total.subTotal) }}</td>
                                            
                                            <!--Luiz Trindade - Taxa de entrega-->
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(pedido.total.deliveryFee) }}</td>
    
                                            <!--Luiz Trindade - Status do pedido-->
                                            <td v-if="pedido.fullCode == 'PLACED'" style="color: green; text-align: center;">
                                                FEITO<br>
                                                <span class="badge badge-danger">Não importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'CONFIRMED'" style="color: green; text-align: center;">
                                                CONFIRMADO<br>
                                                <span class="badge badge-primary" style="background-color: green;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'PREPARATION_STARTED'" style="color: yellow; text-align: center;">
                                                PREPARAÇÃO INICIADA<br>
                                                <span class="badge badge-primary" style="background-color: green;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'DISPATCHED'" style="color: cyan; text-align: center;">
                                                ENVIADO<br>
                                                <span class="badge badge-primary" style="background-color: green;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'READY_TO_PICKUP'" style="color: blue; text-align: center;">
                                                PRONTO PARA RETIRADA<br>
                                                <span class="badge badge-primary" style="background-color: green; text-align: center;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'DELIVERY_DROP_CODE_REQUESTED'" style="color: green; text-align: center;">
                                                DROPCODE REQUISITADO<br>
                                                <span class="badge badge-primary" style="background-color: green;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'CONCLUDED'" style="color: green; text-align: center;">
                                                CONCLUÍDO<br>
                                                <span class="badge badge-primary" style="background-color: green;">Importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'CANCELLATION_REQUESTED'" style="color: red; text-align: center;">
                                                EM CANCELAMENTO<br>
                                                <span class="badge badge-danger">Não importado</span>
                                            </td>
                                            <td v-else-if="pedido.fullCode == 'CANCELLED'" style="color: red; text-align: center;">
                                                CANCELADO<br>
                                                <span class="badge badge-danger">Não importado</span>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                                
                                <div style="text-align: center;" v-show="lstPedidosIfoodDetalhadosAnteriores.length == 0">
                                    <h6>Não há pedidos no momento...</h6>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <!--Luiz Trindade - Botão para cancelar e fechar o modal-->
                    <div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" 
                            data-dismiss="modal">
                            <i class="fa fa-close"></i> 
                            Cancelar
                        </button>
					</div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
	import util from '../utilitarios/util.js'
    import axios from 'axios';
    
	export default {
        name : "cmplistarpedidosifood",

        components:{
            VueBootstrap4Table,
            vPagination,
        },

        //Propriedades de variáveis que precisam ser passadas entre componentes
        props: {
            lstPedidosIfoodSocketIO: {
                type: Array,
                required: true
            },
            lstPedidosIfoodAnterioresSocketIO: {
                type: Array,
                required: true
            }
        },

		data: function () {
			return {
                axios                                   : require("axios"),
                intervalId                              : null,

                //Luiz Trindade - Variáveis relacionadas aos pedidos do ifood
                lstPedidosIfood                         : [],
                lstPedidosIfoodDetalhados               : [],
                lstPedidosIfoodDetalhadosAnteriores     : [],
                clientID                                : "",
                clientSecret                            : "",
                merchantId                              : "",
                accessToken                             : "",
                detalhesPedidos                         : [],

                //Luiz Trindade - Variáveis de detalhes de pedidos
                detalheNome                             : "",
                detalhePedido                           : "",
                detalheDataPreparo                      : "",
                detalhesItens                           : [],
                
                taxasAdicionais                         : 0,
                vantagensAdicionais                     : 0,
                taxaEntrega                             : 0,
                valortotal                              : 0,
                subTotal                                : 0,
                
                //Luiz Trindade - Lista para armazenar os códigos externos de um pedido 
                lstExternalCodesPdvCodes                : [],
                connIo                                  : null,
            }
        },

		methods: {
            //Uso de uma função do utils para formatar valores decimais
            mtdformatavalordecimal(valor, digitos){
				try {
					return util.formatavalordecimais(valor, digitos);
				}
				catch (e) {
					return 0;
				}
			},

            //Luiz Trindade - Método para exportar os códigos do pdv para o elemento pai
            exportarExternalCodes() {
                return this.lstExternalCodesPdvCodes;
            },

            //Luiz Trindade - Método para formatar variáveis // ATUALIZAR PARA COLOCAR TODAS AS NOVAS VARIÁVEIS
            mtdFormatarVariaveis() {
                this.lstPedidosIfood                        = [];
                this.lstPedidosIfoodDetalhados              = [];
                this.lstPedidosIfoodDetalhadosAnteriores    = [];
                this.clientID                               = "";
                this.clientSecret                           = "";
                this.accessToken                            = "";
                this.orderID                                = "";
                this.merchantId                             = ""; 
                this.detalhesPedidos                        = []; 
                
                this.detalheNome                            = "";
                this.detalhePedido                          = "";
                this.detalheDataPreparo                     = "";
                this.detalhesItens                          = [];

                this.taxasAdicionais                        = 0;
                this.vantagensAdicionais                    = 0;
                this.taxaEntrega                            = 0;
                this.valorTotal                             = 0;
                this.subTotal                               = 0;

                this.lstExternalCodesPdvCodes               = [];
                this.connIo                                 = null;

                localStorage.setItem("lstExternalCodesPdvCodes", JSON.stringify(this.lstExternalCodesPdvCodes));
                // localStorage.setItem("ifoodOrderId", "");
            },

            //Luiz Trindade - Método para exibir o modal de listagem de pedidos anteriores 
            //que foram realizados e importados do ifood
            mtdexibirmodalpedidosanteriores() {
                $("#mdlistarpedidosifoodanteriores").modal("show");
            },

            //Luiz Trindade - Função que verifica a existência de um produto antes de importar para venda no pdv
            verificarexistenciaproduto(orderId) {
                let parametros = [
                    {parametro: "op",               valor: "verificarexistenciaproduto"},
                    {parametro: "clientId",         valor: this.clientID},
                    {parametro: "clientSecret",     valor: this.clientSecret},
                    {parametro: "orderId",          valor: orderId},
                    {parametro: "idclientesac",     valor: this.$store.state.usuario.idclientesac},
                ];
                
                let retorno = util.reqaxios(
                    parametros, "POST", 
                    this.$store.state.usuario.adrsrv+
                    "/controller/API/ifood/ifoodRequestApi.php"
                );
                retorno.then((response) => {
                    const content = response.data;

                    if (content == 0) {
                        this.importarPedidoIfood(orderId);           
                    } else {
                        this.$toastr.w("Pedido possui itens que não estão cadastrados ou que não possuem código válido!", "Atenção!");
                    }
                }).catch((response) =>{
                    //Log do erro
                    console.log(response);
                });
            },

            //Luiz Trindade - Função para conseguir 
            //informações de um produto pelo id
            importarPedidoIfood(orderId) {
                //Setar id do pedido no localstorage para ser recuperado
                localStorage.setItem("ifoodOrderId", orderId);
                console.log("ID DO PEDIDO: ", orderId);

                //Remover o elemento da lista
                this.lstPedidosIfoodDetalhados = this.lstPedidosIfoodDetalhados.filter(element => element.id !== orderId);
                
                let parametros = [
                    {parametro: "op",               valor: "getExternalCodeList"},
                    {parametro: "clientId",         valor: this.clientID},
                    {parametro: "clientSecret",     valor: this.clientSecret},
                    {parametro: "orderId",          valor: orderId},
                    {parametro: "idclientesac",     valor: this.$store.state.usuario.idclientesac},
                ];
                
                let retorno = util.reqaxios(
                    parametros, "POST", 
                    this.$store.state.usuario.adrsrv+
                    '/controller/API/ifood/ifoodRequestApi.php'
                );
                retorno.then((response) => {
                    const content = response.data;
                    // console.log(content)

                    if (content == 1) {
                        this.$toastr.w('Pedido já importado!', 'Atenção!');
                        localStorage.setItem("ifoodOrderId", "");
                    } else {
                        //Confirmar o pedido
                        this.confirmOrder(orderId);

                        //Definir a lista de externalcodes no localstorage
                        localStorage.setItem("lstExternalCodesPdvCodes", JSON.stringify(response.data));
                        //Executar uma função no elemento pai
                        this.$emit("triggerParentFunction");
                    }
                }).catch((response) =>{
                    //Log do erro
                    console.log(response);
                });
            },

            //Luiz Trindade - Função para confirmar o pedido do ifood
            confirmOrder(orderId) {
                // const url = "http://localhost:3000/ifood/confirmOrder";
                const url = 'https://app-rillsoft.com.br/ifood/confirmOrder';
                
                let parametros = [
                    {parametro: "clientId"      , valor: this.clientID},
                    {parametro: "clientSecret"  , valor: this.clientSecret},
                    {parametro: "orderId"       , valor: orderId},
                ]
                let vself = this;
                let retorno = util.reqaxios3(parametros, "POST", url)
                .then(response => {
                    console.log("Resposta:", response.data);
                })
                .catch(error => {
                    console.error("Erro:", error);
                });
            },

            showOrderDetails(orderId){
                let parametros = [
                    {parametro: "op",           valor: "getOrderDetails"},
                    {parametro: "clientId",     valor: this.clientID},
                    {parametro: "clientSecret", valor: this.clientSecret},
                    {parametro: "orderId",      valor: orderId},
                ];
                
                // const url = "http://localhost:3000/ifood/getOrderDetails";
                const url = "https://app-rillsoft.com.br/ifood/getOrderDetails";
                
                let vself = this;
                let retorno = util.reqaxios3(parametros, 'post', url)
                .then(function (response) {
                    const content = response.data;

                    vself.detalheNome                = content.customer.name;
                    vself.detalhePedido              = content.displayId;
                    vself.detalheDataPreparo         = vself.formatarDataIfood(content.preparationStartDateTime);
                    vself.detalhesItens              = content.items;

                    vself.taxasAdicionais            = content.total.additionalFees;
                    vself.vantagensAdicionais        = content.total.benefits;
                    vself.taxaEntrega                = content.total.deliveryFee;
                    vself.valorTotal                 = content.total.orderAmount;
                    vself.subTotal                   = content.total.subTotal;

                    $("#mdldetalhespedidoifood").modal("show");
                }).catch(function (response) {
                    console.log(response);
                });

            },

            //Luiz Trindade - Método para formatar data do ifood.
            formatarDataIfood(dataIfood) {
                let dateStr = dataIfood;
                let date = new Date(dateStr);

                const options = {
                    year    : 'numeric',
                    month   : '2-digit',
                    day     : '2-digit',
                    hour    : '2-digit',
                    minute  : '2-digit',
                    hour12  : false
                };

                const formattedDate = date.toLocaleString('pt-BR', options);
                return formattedDate.replace(",", "");
            },

            //Luiz Trindade - Pegar o ClientID, ClientSecret e MerchantID da filial
            mtdinformacoesclientemerchant() {
                let parametros = [
                    {parametro: "op",               valor: "informacoesclientemerchant"},
                    {parametro: "idclientesac",     valor: this.$store.state.usuario.idclientesac},
                    {parametro: "idfilial",         valor: this.$store.state.filialpadrao.codfil},
                ];
                
                // console.log("idfilial:", this.$store.state.filialpadrao.codfil);

                let retorno = util.reqaxios(
                    parametros, "post", 
                    this.$store.state.usuario.adrsrv+
                    '/controller/API/ifood/ifoodRequestApi.php'
                );

                retorno.then((response) => {
                    const content = response.data; 
                    
                    this.clientID       = content[0].clientid;
                    this.clientSecret   = content[0].clientsecret;
                    this.merchantId     = content[0].merchantid;

                    // console.log(content);
                    // console.log("clientId:", this.clientID);
                    // console.log("clientSecret:", this.clientSecret);
                }).catch((response) =>{
                    //Log do erro
                    console.log(response);
                });
            },
        },

        mounted: function () {
            if (util.verificasessao(this)) {
                let vself 			= this;
				vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;							
                let loader 			= vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
					vself.planocliente  = response.data.plnc;	
					vself.resumoformas  = util.opcaousuario('020Z.015Z.135Z', vself.$store.state.perfilusuario);
                    if (util.opcaousuario('020Z.015Z', vself.$store.state.perfilusuario)) {
                        vself.mtdFormatarVariaveis();
                        vself.mtdinformacoesclientemerchant();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            }
        },

        computed: {            						
        },

        watch:{
            lstPedidosIfoodSocketIO: {
                handler: function (newVal, oldVal) {
                    // console.log("Nova lista de pedidos: ", newVal);
                    // console.log("newVal: ", JSON.parse(newVal));

                    if (newVal != []) {
                        // Tratamento da lista lstPedidosIfoodDetalhados
                        const confirmedOrderIds = newVal.filter(element => 
                            element.fullCode == "CONFIRMED"                     ||
                            element.fullCode == "PREPARATION_STARTED"           ||
                            element.fullCode == "DISPATCHED"                    ||
                            element.fullCode == "READY_TO_PICKUP"               ||
                            element.fullCode == "DELIVERY_DROP_CODE_REQUESTED"  ||
                            element.fullCode == "CANCELLATION_REQUESTED"        ||
                            element.fullCode == "CONCLUDED"                     ||
                            element.fullCode == "CANCELLED"                     
                        ).map(element => element.id);
                        let tempArray = newVal.filter(element => !confirmedOrderIds.includes(element.id));
                        this.lstPedidosIfoodDetalhados = tempArray.reverse();
                        localStorage.setItem("lstPedidosIfoodDetalhadosTamanho", this.lstPedidosIfoodDetalhados.length);
                        // this.lstPedidosIfoodDetalhados = newVal;
                    }

                    // this.lstPedidosIfoodDetalhados = newVal;
                    // this.lstPedidosIfoodDetalhados.push(newVal);
                    // console.log(this.lstPedidosIfoodDetalhados);
                },
                deep: true
            },

            lstPedidosIfoodAnterioresSocketIO: {
                handler: function (newVal, oldVal) {
                    // console.log('Detalhes pedidos:');
                    // console.log("Anteriores:", typeof newVal, newVal);
                    if (newVal != []) {
                        this.lstPedidosIfoodDetalhadosAnteriores = [...newVal].reverse();
                    }
                    // this.lstPedidosIfoodDetalhadosAnteriores.push(newVal);
                    // this.lstPedidosIfoodDetalhadosAnteriores.push(JSON.parse(newVal));
                    // console.log(this.lstPedidosIfoodDetalhados);
                },
                deep: true
            }
        }            
    }
</script>

<style>
</style>    